import * as PropTypes from 'prop-types';
import { ColDef } from 'ag-grid';
import { GridProps } from 'semantic-ui-react';
import { RouteComponentProps } from 'react-router';

export interface Props extends RouteComponentProps {
  data: object;
  colDef: ColDef;
  context: GridProps;
}

export interface LinkProps {
  callback: (id: string) => void;
  path?: string;
}

export const propTypes = {
  data: PropTypes.object.isRequired
};



// WEBPACK FOOTER //
// ./src/components/user-grid/cell/renderers/link/props.ts